module.exports = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$isLongestChain = _ref.isLongestChain,
    isLongestChain = _ref$isLongestChain === void 0 ? false : _ref$isLongestChain,
    _ref$hasGoldenTicket = _ref.hasGoldenTicket,
    hasGoldenTicket = _ref$hasGoldenTicket === void 0 ? false : _ref$hasGoldenTicket;
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$showLongestChai = _ref2.showLongestChain,
    showLongestChain = _ref2$showLongestChai === void 0 ? false : _ref2$showLongestChai;
  var badges = [];
  if (hasGoldenTicket) {
    badges.push("\n      <span class=\"explorer-feed-badge explorer-feed-status-badge\" title=\"Golden ticket\" aria-label=\"Golden ticket\">\n        <i class=\"fas fa-ticket\" aria-hidden=\"true\"></i>\n      </span>\n    ");
  }
  if (showLongestChain && isLongestChain) {
    badges.push("\n      <span class=\"explorer-feed-badge explorer-feed-status-badge\" title=\"On longest chain\" aria-label=\"On longest chain\">\n        <i class=\"fas fa-chain\" aria-hidden=\"true\"></i>\n      </span>\n    ");
  }
  return badges.length ? "<div class=\"explorer-feed-badges\">".concat(badges.join(''), "</div>") : '';
};